import { Component } from '@angular/core';

@Component({
  templateUrl: '../views/page-not-found.component.html',
})
export class PageNotFoundComponent {}
